module.exports = {
	"name": "WebSPH",
	"version": "0.9.2",
	"license": "MIT",
	"dependencies": {
		"@angular/animations": "^4.0.0",
		"@angular/common": "^4.0.0",
		"@angular/compiler": "^4.0.0",
		"@angular/core": "^4.0.0",
		"@angular/forms": "^4.0.0",
		"@angular/http": "^4.0.0",
		"@angular/platform-browser": "^4.0.0",
		"@angular/platform-browser-dynamic": "^4.0.0",
		"@angular/router": "^4.0.0",
		"core-js": "^2.4.1",
		"rxjs": "5.4.2",
		"zone.js": "^0.8.4"
	},
	"devDependencies": {
		"@angular/cli": "1.3.1",
		"@angular/compiler-cli": "^4.0.0",
		"@angular/language-service": "^4.0.0",
		"@types/gl-matrix": "^2.2.34",
		"@types/jasmine": "2.5.45",
		"@types/node": "^8.0.22",
		"codelyzer": "~3.0.1",
		"file-loader": "^0.11.2",
		"gl-matrix": "^2.3.2",
		"jasmine-core": "~2.6.2",
		"jasmine-spec-reporter": "~4.1.0",
		"shader-loader": "^1.3.0",
		"ts-loader": "^2.0.3",
		"ts-node": "~3.0.4",
		"tslint": "~5.3.2",
		"typescript": "~2.4.2",
		"webpack": "^2.2.1"
	},
	"scripts": {
		"buildOld": "webpack",
		"buildNew": "ng build -aot"
	}
};


//////////////////
// WEBPACK FOOTER
// D:/[Projects]/WebSPH.gits/WebSPH.git/package.json
// module id = ../../../../../package.json
// module chunks = main